

import { mapState } from 'vuex'
import utils from '@/components/tools/utils'
import time from '@/components/tools/time'

export default {

  props: {
    endingAtAsString: {
      type: String,
      default: undefined
    },
    messagePrefix: {
      type: String,
      default: undefined
    },
    superShort: {
      type: Boolean,
      default: false
    },
    onCountdownFinish: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    now: Date.now(),
    interval: undefined
  }),

  computed: {
    ...mapState('general', ['differenceToServerTime']),
    endingAt () {
      return Date.parse(this.endingAtAsString)
    },
    ready () {
      return this.endingAt
    },

    leftTimeEndingAt () {
      const now = Date.now() - this.differenceToServerTime

      return this.endingAt - now
    }
  },

  mounted () {
    const that = this
    this.interval = setInterval(function () {
      that.now = Date.now() - that.differenceToServerTime
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    formatDate (value) {
      return utils.formatDateLong(value, this.$i18n.locale)
    },
    inWords (timeObj) {
      return time.inWords(timeObj, this)
    },

    inSuperShort (timeObj) {
      return time.inWords(timeObj, this)
    },
    inHoursMinutesAndSeconds (timeObj) {
      return time.inHoursMinutesAndSeconds(timeObj, this)
    }

  }
}

